import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m12 12.708-5.246 5.246a.502.502 0 0 1-.345.15.466.466 0 0 1-.363-.15.49.49 0 0 1-.16-.354.49.49 0 0 1 .16-.354L11.292 12 6.046 6.754a.503.503 0 0 1-.15-.345.466.466 0 0 1 .15-.363.49.49 0 0 1 .354-.16.49.49 0 0 1 .354.16L12 11.292l5.246-5.246a.503.503 0 0 1 .345-.15.466.466 0 0 1 .363.15.49.49 0 0 1 .16.354.49.49 0 0 1-.16.354L12.708 12l5.246 5.246a.502.502 0 0 1 .15.345.466.466 0 0 1-.15.363.49.49 0 0 1-.354.16.49.49 0 0 1-.354-.16L12 12.708Z" }, null, -1)
  ]))]))
}
export default { render: render }